import React from 'react'

export default function CopyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0246 3.39033C15.8721 3.39044 16.5598 4.07792 16.5598 4.92549V11.6032C16.5596 12.4507 15.8721 13.1383 15.0246 13.1384H13.2199V14.9421C13.2199 15.7897 12.5323 16.4771 11.6848 16.4772H5.00702C4.15939 16.4772 3.47186 15.7897 3.47186 14.9421V8.26435C3.47189 7.41675 4.1594 6.7292 5.00702 6.7292H6.81171V4.92549C6.81171 4.07786 7.49923 3.39033 8.34686 3.39033H15.0246ZM5.00702 8.12959C4.9326 8.12959 4.87228 8.18994 4.87225 8.26435V14.9421C4.87225 15.0165 4.93259 15.0769 5.00702 15.0769H11.6848C11.7591 15.0767 11.8195 15.0165 11.8195 14.9421V13.1384H8.34686C7.4993 13.1384 6.81181 12.4508 6.81171 11.6032V8.12959H5.00702ZM8.34686 4.79072C8.27243 4.79072 8.2121 4.85106 8.2121 4.92549V11.6032C8.2122 11.6776 8.2725 11.738 8.34686 11.738H15.0246C15.0989 11.7379 15.1593 11.6775 15.1594 11.6032V4.92549C15.1594 4.85112 15.0989 4.79083 15.0246 4.79072H8.34686Z"
        fill="currentColor"
      />
    </svg>
  )
}
